import { COMPILED_CONSTANTS } from '../../CompiledConstants'
import { IUser } from '../../definitions/Users'
import ApiUrlCompiler from '../api_urls/ApiUrlCompiler'
import API_URLS from '../ApiUrls'
import HttpClient from '../HttpClient'

class AuthApiClientClass {
    getCognitoRedirectURL = async (redirect: string): Promise<string> => {
        const { url, headers } = ApiUrlCompiler.compile(API_URLS.os.getCognitoRedirectURL)
        const body = {
            redirect: redirect
        }

        const res = await HttpClient.post<string>(url, body, headers)
        return res
    }

    checkAuthorization = async (idToken: string, accessToken: string, onError?: (response: Response) => void): Promise<boolean> => {
        const { url } = ApiUrlCompiler.compile(API_URLS.os.checkAuthorization)
        const body = {
            idToken,
            accessToken
        }

        const newHeaders: HeadersInit = [
            ['Authorization', idToken],
            ['x-apigw-api-id', COMPILED_CONSTANTS.evolveOSApiGatewayId]
        ]

        return await HttpClient.post<boolean>(url, body, newHeaders, onError)
    }

    getLoginUserData = async (idToken: string): Promise<IUser> => {
        const { url } = ApiUrlCompiler.compile(API_URLS.os.getLoginUserData)
        const body = {}

        const newHeaders: HeadersInit = [
            ['Authorization', idToken],
            ['x-apigw-api-id', COMPILED_CONSTANTS.evolveOSApiGatewayId]
        ]

        return await HttpClient.post<IUser>(url, body, newHeaders)
    }

    getCognitoLogoutURL = async (redirect: string): Promise<string> => {
        const { url, headers } = ApiUrlCompiler.compile(API_URLS.os.getCognitoLogoutURL)
        const body = { redirect }
        return await HttpClient.post<string>(url, body, headers)
    }
}

const AuthApiClient = new AuthApiClientClass()
export default AuthApiClient
